var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isApple,
          expression: "!isApple",
        },
      ],
    },
    [
      _vm._t("note"),
      _vm._v(" "),
      _c(
        "dl",
        { staticClass: "formContainer confirm" },
        [
          _vm.isEmailField
            ? [
                _c("dt", [_vm._v("メールアドレス")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.userinfo.email))]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("dt", [_vm._v("ＪリーグID")]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.userinfo.jleague_id))]),
          _vm._v(" "),
          _vm.isSignup
            ? [
                _c("dt", [_vm._v("パスワード")]),
                _vm._v(" "),
                _c("dd", [_vm._v("**********")]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("dt", [_vm._v("生年月日")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(_vm._s(_vm._f("filterBirthday")(_vm.userinfo.birthday_ymd))),
          ]),
          _vm._v(" "),
          !_vm.isSignup || _vm.isSignupFull
            ? [
                _c("dt", [_vm._v("氏名")]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(
                    _vm._s(
                      _vm._f("filterMemberName")(
                        "",
                        _vm.userinfo.member_last_nm,
                        _vm.userinfo.member_first_nm
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("dt", [_vm._v("氏名")]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(
                    _vm._s(
                      _vm._f("filterMemberName")(
                        "",
                        _vm.userinfo.member_last_nm_kana,
                        _vm.userinfo.member_first_nm_kana
                      )
                    )
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("dt", [_vm._v("性別")]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm._f("filterSex")(_vm.userinfo.sex_kbn)))]),
          _vm._v(" "),
          !_vm.isSignup || _vm.isSignupFull
            ? [
                _c("dt", [_vm._v("郵便番号")]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(
                    _vm._s(
                      _vm._f("filterPostCode")(
                        "",
                        _vm.userinfo.post_cd1,
                        _vm.userinfo.post_cd2
                      )
                    )
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("dt", [_vm._v("都道府県")]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.userinfo.address_state))]),
          _vm._v(" "),
          !_vm.isSignup || _vm.isSignupFull
            ? [
                _c("dt", [_vm._v("市区町村")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.userinfo.address_city))]),
                _vm._v(" "),
                _c("dt", [_vm._v("町域番地")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.userinfo.address_street))]),
                _vm._v(" "),
                _c("dt", [_vm._v("建物号室")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.userinfo.address_building))]),
                _vm._v(" "),
                _c("dt", [_vm._v("電話番号")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.userinfo.tel_no_fixed))]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isSignup
            ? [
                _c("dt", [_vm._v("お気に入りクラブ")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.strFavoriteClubs))]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isSignup
            ? [
                _c("dt", [_vm._v("お気に入り選手")]),
                _vm._v(" "),
                _c("dd", {
                  domProps: { innerHTML: _vm._s(_vm.formattedFavoritePlayers) },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      [_vm._t("recaptchaUserInfo")],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btnSpace duo" },
        [
          _c(
            "button",
            {
              staticClass: "return",
              attrs: { type: "button" },
              on: { click: _vm.back },
            },
            [_vm._v("戻る")]
          ),
          _vm._v(" "),
          _vm.isSignup
            ? _c("xhr-button", {
                attrs: {
                  "is-xhr": _vm.isXhr,
                  "gtm-event-id": "regist_confirm_tap2",
                  "button-label": "登録",
                  "button-type": "submit",
                },
              })
            : _c("xhr-button", {
                attrs: {
                  "is-xhr": _vm.isXhr,
                  "button-label": "登録",
                  "button-type": "submit",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "none" } }, [
        _c("button", { ref: "siwa_signup_button", attrs: { type: "submit" } }),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }